export const navigation = {
tabs: {
home: "Accueil",
assets: "Actifs",
work: "Travail",
reports: "Rapports",
contacts: "Contacts",
analytics: "Analytique",
account: "Compte",
},
planLapsed: {
member: "Le forfait de cet espace de travail n'inclut plus les équipes. Vous pouvez tout consulter, mais ne rien modifier — demandez au propriétaire de l'espace de rétablir le forfait.",
},
mobile: {
moreTab: "Plus",
scanTab: "Scanner",
moreSubtitle: "Le reste de votre espace de travail, et des raccourcis.",
planLockedA11y: "{{label}}, non inclus dans votre offre. Ouvre les offres qui l’incluent.",
overflowSection: "Raccourcis",
overflow: {
  sites: "Sites",
contacts: "Contacts",
reports: "Rapports",
analytics: "Analytique",
knowledge: "Connaissances",
guide: "Aide",
assistant: "Assistant IA",
activity: "Activité",
calendar: "Calendrier",
checklists: "Listes de contrôle",
groupRules: "Règles de groupe",
compliance: "Conformité",
inspections: "Inspections",
jobs: "Interventions",
people: "Personnes",
profile: "Profil",
},
},
stack: {
forgotPassword: "Mot de passe oublié",
setNewPassword: "Nouveau mot de passe",
newAsset: "Nouvel actif",
editAsset: "Modifier l'actif",
addDocument: "Ajouter un document",
renewDocument: "Renouveler le document",
newChecklist: "Nouvelle liste de contrôle",
newInspection: "Nouvelle inspection",
shareReport: "Envoyer le rapport",
convertToJobs: "Créer des interventions",
inspectionReview: "Revue d’inspection",
contractors: "Entrepreneurs",
contractorHome: "Accueil entrepreneur",
scheduleInspection: "Planifier une inspection",
scheduleDetails: "Détails de la planification",
calendar: "Calendrier",
teamManagement: "Gestion d’équipe",
teamInvitation: "Invitation d’équipe",
workspaceAiAudit: "Audit IA de l’espace de travail",
workspaceBilling: "Facturation et utilisation",
contactInvitation: "Invitation de contact",
asset: "Actif",
submitQuote: "Soumettre un devis",
inviteOnly: "Sur invitation uniquement",
privateRequest: "Demande privée",
quoteRequest: "Demande de devis",
inspectionReport: "Rapport d’inspection",
checklist: "Check-list",
quotes: "Devis",
jobsCreated: "Interventions créées",
reviewContact: "Examiner le contact",
reviewContactSub: "Modifier et ajouter des rôles",
inspectionComplete: "Inspection terminée",
requestQuotes: "Demander des devis",
generateWithAI: "Générer avec l’IA",
generateWithAISub: "Suggérer un brouillon de liste de contrôle",
generationFailed: "Échec de la génération",
reviewAssign: "Examiner et assigner",
reviewAssignListSub_one: "{{count}} intervention · Choisir qui s’en charge et attribuer",
reviewAssignListSub_other: "{{count}} interventions · Choisir qui s’en charge et attribuer",
importContacts: "Importer des contacts",
importContactsSub: "Comment souhaitez-vous les ajouter ?",
phonePicker: "Contacts du téléphone",
phonePickerSub: "Un contact par sélection",
suggestedJobs: "Interventions de suivi",
saveWorkflowTemplate: "Enregistrer la check-list de flux de travail",
sentForApproval: "Envoyé pour approbation",
assetReadOnlyShared: "Lecture seule · Partagé avec vous",
analytics: "Analytique",
analyticsScope: "Portée : {{label}}",
scheduledInspection: "Inspection planifiée",
scheduleFallback: "Planification",
sharedKnowledge: "Connaissance partagée",
settings: "Paramètres",
help: "Aide",
preferences: "Préférences",
deleteAccount: "Supprimer le compte",
contact: "Contact",
addContact: "Ajouter un contact",
editContact: "Modifier le contact",
contractorDirectory: "Répertoire des entrepreneurs",
importFromContacts: "Importer depuis les contacts",
addContractor: "Ajouter un entrepreneur",
alreadyExists: "Existe déjà",
updateContractor: "Mettre à jour l’entrepreneur",
inspection: "Inspection",
job: "Intervention",
convertToJobsApproved_one: "{{count}} approuvée",
convertToJobsApproved_many: "{{count}} approuvées",
convertToJobsApproved_other: "{{count}} approuvées",
reviewAssignListSub_many: "{{count}} d’interventions · Choisir qui s’en charge et attribuer",
recurringJobCreate: "Nouveau plan de maintenance",
},
scopeChip: {
all: "Tout",
personal: "Personnel",
teamNamed: "Équipe : {{name}}",
teamFallback: "Équipe",
modalTitle: "Portée",
cancel: "Annuler",
a11y: "Filtre d’espace de travail, {{label}}",
},
shell: {
brandTitle: "AssetWRX",
brandSubtitle: "Plateforme d'opérations d'actifs",
navSection: "Navigation",
sectionOperate: "Exploiter",
sectionNetwork: "Réseau",
sectionInsights: "Analytique",
sectionAccount: "Compte",
brandHomeA11y: "Accueil AssetWRX",
brandHomeWithWorkspaceA11y: "{{workspace}} · Accueil AssetWRX",
collapseNav: "Réduire la navigation",
expandNav: "Développer la navigation",
primaryNavA11y: "Navigation principale",
accountA11y: "Compte",
notificationsA11y: "Notifications",
skipToContent: "Aller au contenu principal",
notificationsA11yUnread_one: "Notifications, {{count}} non lue",
notificationsA11yUnread_many: "Notifications, {{count}} non lues",
notificationsA11yUnread_other: "Notifications, {{count}} non lues",
notificationsA11yUnreadMany: "Notifications, plus de 99 non lues",
activitySheetTitle: "Notifications",
activityUnreadSubtitle_one: "{{count}} non lue",
activityUnreadSubtitle_many: "{{count}} non lues",
activityUnreadSubtitle_other: "{{count}} non lues",
activityUnreadSubtitleCapped: "Plus de {{limit}} non lues",
activityEmpty: "Pas encore de notifications",
activitySeeAll: "Toute l’activité",
accountRailA11y: "Sections des paramètres",
accountRailTitle: "Paramètres",
accountRailSubtitle: "Compte personnel, espace de travail et administration",
sectionPersonal: "Vous",
sectionWorkspace: "Espace de travail",
sectionTeam: "Équipe",
sectionAdmin: "Administration",
accountNavProfile: "Profil",
accountNavPersonalDetails: "Détails du profil",
accountNavPreferences: "Préférences",
accountNavHelp: "Aide",
accountNavWorkspaceOverview: "Vue d’ensemble",
accountNavDefaults: "Valeurs par défaut",
accountNavOrganization: "Organisation",
accountNavBranding: "Image de marque",
accountNavTeam: "Équipe et invitations",
accountNavBilling: "Facturation et utilisation",
accountNavIntegrations: "Intégrations",
accountNavSyncCenter: "Modifications non envoyées",
accountNavApiExplorer: "Explorateur API",
accountNavAudit: "Audit IA et automatisation",
accountNavTemplates: "Check-lists",
accountNavFeatures: "Fonctionnalités",
accountNavDiagnostics: "Diagnostics",
accountNavAbout: "À propos",
accountNavIndustryPacks: "Packs sectoriels",
accountNavAssetTypes: "Types d’actifs",
accountNavAi: "Audit d’utilisation de l’IA",
accountNavAssistantActivity: "Activité de l'assistant",
accountNavPrivacy: "Confidentialité",
accountNavBillingShort: "Facturation",
accountNavTeams: "Équipes",
accountNavSecurity: "Sécurité",
accountNavNotifications: "Notifications",
accountNavBrandingDefaults: "Image de marque et valeurs par défaut",
accountNavHandbook: "Guide d’intégration",
sectionAdvanced: "Avancé",
railBackToSettings: "Tous les paramètres",
railAssistant: "Assistant",
railIntegrations: "Automatisations",
railBilling: "Facturation",
},
  // The header trail on detail screens: Site › Asset › work item › Report.
  trail: {
    sites: 'Sites',
    site: 'Site',
    assets: 'Actifs',
    asset: 'Actif',
    inspection: 'Inspection',
    job: 'Intervention',
    report: 'Rapport',
    plan: 'Planification',
    document: 'Document',
    contacts: 'Contacts',
    contact: 'Contact',
  },
};
